import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { MyGlobal, MyAlert } from '../GlobalContext';
import CanvasDraw from "react-canvas-draw";
import { Link } from 'react-router-dom';
import Resizer from "react-image-file-resizer";
import * as $ from 'jquery';

export class CaptureSignature extends Component {
    static displayName = CaptureSignature.name;

    constructor(props) {
        super(props);
        this.state = {
            driversSignature: "",
            loading: false,
            alertMessage: "",
            selectedManifestNumber: "",
            selectedCarrierId: "",
            driversName: "",
            consignmentSummary: [],
            totalConsignments: 0,
            totalPallets: 0,
            totalCartons: 0,
            vehicleLicensePlate: "",
            uploadedImage: "",
            resizedImageUri:""
        };
        this.history = props.history;
    }

    componentDidMount() {

        var currentState = this.props.location.state;
        if (currentState && currentState.CreateManifestResponse) {
            this.setState({ alertMessage: currentState.CreateManifestResponse});
        }
        if (currentState && currentState.ManifestNumber) {
            this.setState({ selectedManifestNumber: currentState.ManifestNumber });
        }
        if (currentState && currentState.CarrierId) {
            this.setState({ selectedCarrierId: currentState.CarrierId });
        }
        if (currentState && currentState.consignmentSummary) {
            if (currentState.consignmentSummary.length > 0) {

                this.setState({ consignmentSummary: currentState.consignmentSummary, totalConsignments: currentState.consignmentSummary.length });
                currentState.consignmentSummary.map(consignmentDetails => {
                    this.state.totalCartons += consignmentDetails.cartons;
                    this.state.totalPallets += consignmentDetails.pallets;
                });
               
            }
        }
    }
    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }

    handleFileSelect = (file) => {

        
        const resizeCompletedEvent = (newFileUri, imageMeta) => {
            if (newFileUri) {
                this.state.uploadedImage = newFileUri.split(';base64,')[1];
                var sizeInBytes = 4 * Math.ceil((this.state.uploadedImage.length / 3)) * 0.5624896334383812;
                var sizeInKb = sizeInBytes / 1000;
                if (sizeInKb >= 500) {
                    this.setState({ loading: false, alertMessage: "Uploaded image is very large.", uploadedImage: "", resizedImageUri: "" });
                    $("#captureImage").val(null);
                    return;
                }
                else {
                    this.state.resizedImageUri = newFileUri;
                }
            }
            this.setState({ loading: false, alertMessage: "" });
           
        };

        const resizeImage = (imageFile) => {
            this.setState({ loading: true, alertMessage: "" });
            try {
                Resizer.imageFileResizer(
                    imageFile,
                    200,
                    200,
                    "JPEG",
                    75,
                    0,
                    resizeCompletedEvent,
                );
            } catch (err) {
                console.log(err);
                this.setState({ loading: false, alertMessage: err.message, uploadedImage: "", resizedImageUri: "" });
                $("#captureImage").val(null);
                return;
            }
        };

        const handleImageResize = (event) => resizeImage(file);
        handleImageResize();
    };

    saveSignature(canvasData) {
        if (!this.state.driversName) {
            this.setState({ alertMessage: "Drivers name and signature is required" });
            return;
        }
        if (!this.state.selectedCarrierId || !this.state.selectedManifestNumber) {
            this.setState({ alertMessage: "Failed to save Signature!! Please create a Manifest first" });
            return;
        }
        var signatureToSave = canvasData.getDataURL().split(';base64,')[1];
        this.setState({ loading: true, alertMessage: "" });
        const updateManifestRequestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                CarrierId: this.state.selectedCarrierId,
                ManifestNumber: this.state.selectedManifestNumber,
                DriversSignature: signatureToSave,
                DriversName: this.state.driversName,
                VehicleLicensePlate: this.state.vehicleLicensePlate,
                UploadedImage: this.state.uploadedImage
            })
        };
        this.state.loading = true;
        fetch('api/Manifest/UpdateManifest', updateManifestRequestOptions)
            .then(async response => {

                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to save Signature!!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        if (apiResponse.success) {
                            this.setState({ alertMessage: "Signature saved successfully!!" });
                            this.goto("ViewManifest", { manifestNumber: this.state.selectedManifestNumber, carrierId: this.state.selectedCarrierId })
                        }
                        else {
                            this.setState({ alertMessage: "Failed to save Signature!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to save Signature!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }



    render() {


        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";


        return <div className="container" >
            {this.state.loading && <div> <em>Loading ... </em></div>}
            <br />

            <Container>
                <Row>
                    <Col xs={9}>
                    </Col>
                    <Col xs={3}>
                        <Link className="btn btn-success col-12 mb-2" to={{ pathname: "CreateManifest" }}>Back</Link>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <h5>Sign Manifest : {this.state.selectedManifestNumber} </h5>
                        {alertMessage}
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={4}>
                        <label>Total Consignments</label>
                    </Col>
                    <Col xs={4}>
                        {this.state.totalConsignments}
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={4}>
                        <label>Total Cartons</label>
                    </Col>
                    <Col xs={4}>
                        {this.state.totalCartons}
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={4}>
                        <label>Total Pallets</label>
                    </Col>
                    <Col xs={4}>
                        {this.state.totalPallets}
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={4}>
                        <label>Vehicle License Plate</label>
                    </Col>
                    <Col xs={4}>
                        <input value={this.state.vehicleLicensePlate} maxLength="50"
                            onChange={(e) => {
                                this.setState({ vehicleLicensePlate: e.target.value });
                            }} />
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={4}>
                        <label>Driver's Name</label>
                    </Col>
                    <Col xs={4}>
                        <input value={this.state.driversName} maxLength="50"
                            onChange={(e) => {
                                this.setState({ driversName: e.target.value });
                            }} />
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={4}>
                        <label>Take a picture</label>
                    </Col>
                    <Col xs={4}>
                        <input type="file" id="captureImage" onChange={e => this.handleFileSelect(e.target.files[0])}
                            name="picture"
                            accept="image/*"
                            capture="environment" />
                    </Col>
                </Row>
                {this.state.uploadedImage && this.state.resizedImageUri && (
                    <Row className="mb-3">
                        <Col xs={12}>
                            <div><br /><img id="uploadedImage" src={this.state.resizedImageUri} alt="uploaded image" /></div>
                        </Col>
                    </Row>
                )}
                <Row className="mb-3">
                    <Col xs={4}>
                        <label>Driver's Signature</label>
                    </Col>
                    <Col xs={4}>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={12}>
                        <CanvasDraw brushRadius={2} style={{ width: "100%", border: "1px solid black" }} ref={canvasDraw => (this.myCanvas = canvasDraw)} />

                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={12}>
                        <button className="btn btn-success col-12 mb-2 mt-1" disabled={this.state.loading} onClick={() => { this.myCanvas.clear(); }}> Clear </button>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={12}>
                        <button className="btn btn-success col-12 mb-2 mt-1" disabled={this.state.loading} onClick={() => { this.saveSignature(this.myCanvas) }}> Save </button>
                    </Col>
                </Row>
            </Container>
        </div>
    }


}